module.exports = __webpack_public_path__ + "img/JPlogo.87b549cb.png";